export const ID_USER_EMAIL_KEY: string = 'SHDH_user_email';
export const ID_USER_NAME_KEY: string = 'SHDH_user_name';
export const ID_ROLE_NAME_KEY: string = 'SHDH_user_role';
export const ID_USER_ID_KEY: string = 'SHDH_id_user';
export const ID_TOKEN_KEY: string = 'SHDH_id_token';
export const ID_REFRESH_TOKEN_KEY: string = 'SHDH_id_refreshtoken';
export const permissions_key: string = 'SHDH_AAP';